import Components from "../components/mdx";

export default Components;
